import React from 'react'
import {useLocation} from 'react-router-dom'
import Centered from './centered'
import Layout1 from './layout-1'

const Layouts = ({children}) => {
  let location = useLocation()
  let {pathname} = {...location}
  if (
    [
      '/login',
      '/logout',
      '/forgot-password',
      '/map'
    ].includes(pathname)
  ) {
    return <Centered>{children}</Centered>
  } else if (['/landing'].includes(pathname)) {
    return ''
  } else {
    return <Layout1>{children}</Layout1>
  }
}

export default Layouts
